export class UrlTokenInfo {
    name = '';
    organisationName = '';
    organisationLogo?: string;

    deserialize(data: any) {
        this.name = data.name ?? '';
        this.organisationName = data.organisation_name ?? '';
        this.organisationLogo = data.organisation_logo ?? undefined;
        return this;
    }
}
